import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_2 = { key: 1 }

import { useFormattedAddress } from '@/composables/utils/useFormattedAddress';
import { ref } from 'vue';
import Icon from '@/components/Icon.vue';
import WalletConnectors from './WalletConnectors.vue';
import WalletDataList from './WalletDataList.vue';
import { useWallet } from '@/composables/core/useWallet';
import { useLayout } from '@/composables/core/useLayout';
import DisconnectConfirmation from '@/views/wallet/DisconnectConformation.vue';
import { HEADER_HEIGHT } from '@/constants/LAYOUT_PARAMS';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { logout, isInjected, address, isNetworkError } = useWallet();
const formattedAddress = useFormattedAddress(address, { headLength: 6 });
const { layout } = useLayout();
const walletPanel = ref();
const isShowDialog = ref(false);

const toggleWalletPanel = (event?) => {
  walletPanel.value.toggle(event);
};

const onDialogOpen = () => {
  toggleWalletPanel();
  isShowDialog.value = true;
};

const onDialogClose = () => {
  isShowDialog.value = false;
};

const onConfirm = () => {
  logout();
  onDialogClose();
};
const fixOverlayPosition = () => {
  const el = document.querySelector<HTMLElement>('.wallet-panel-multilevel');
  if (el) {
    el.classList.add('fixed');
    el.style.top = `${HEADER_HEIGHT}px`;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: _normalizeClass([{ 'button-danger': _unref(isNetworkError) }, "button-base"]),
      onClick: toggleWalletPanel
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          name: !_unref(isNetworkError) ? 'wallet' : 'danger',
          class: _normalizeClass(["mr-s1", { 'text-muted': !_unref(isNetworkError) }]),
          size: "20"
        }, null, 8, ["name", "class"]),
        (_unref(isInjected))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", null, _toDisplayString(_unref(formattedAddress)), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, "Connect wallet"))
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_OverlayPanel, {
      ref_key: "walletPanel",
      ref: walletPanel,
      class: _normalizeClass(["wallet-panel-multilevel", _unref(layout)]),
      onShow: fixOverlayPosition
    }, {
      default: _withCtx(() => [
        (_unref(isInjected))
          ? (_openBlock(), _createBlock(WalletDataList, {
              key: 0,
              onOpenDialog: onDialogOpen
            }))
          : (_openBlock(), _createBlock(WalletConnectors, {
              key: 1,
              onLogin: toggleWalletPanel
            }))
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_Dialog, {
      visible: isShowDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isShowDialog).value = $event)),
      modal: true,
      showHeader: false,
      dismissableMask: "",
      appendTo: "#app"
    }, {
      default: _withCtx(() => [
        _createVNode(DisconnectConfirmation, {
          onCancel: onDialogClose,
          onConfirm: onConfirm
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})